var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.442,
    height: 19.444,
    viewBox: "0 0 19.442 19.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#003d74;stroke-miterlimit:10;stroke-width:1.5px;}.b{fill:#003d74;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-237.529 -551.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M247.229,552.563a8.95,8.95,0,0,0,0,17.9l8.989.041-.041-8.989a8.949,8.949,0,0,0-8.949-8.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.954,564.876c0,.64,1.24.593,1.24.593v.713h-4.523v-.717s1.24.047,1.24-.593V560.18c-.293-.732-1.461-.877-1.461-.89v-.407h3.5v5.994Z",
    transform: "translate(0 0.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.124,555.568a1.151,1.151,0,1,1-1.151,1.151h0a1.149,1.149,0,0,1,1.15-1.151Z",
    transform: "translate(-0.232 1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4b029522ca6c0572f5e1edb3f8f6833c.svg";
export { ForwardRef as ReactComponent };